"use strict";
exports.__esModule = true;
exports.Tooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var div_1 = tslib_1.__importDefault(require("../div"));
var text_1 = tslib_1.__importDefault(require("../text"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var tooltip_style_1 = require("./tooltip.style");
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content, position = _a.position, color = _a.color, className = _a.className, containerClassName = _a.containerClassName;
    return (react_1["default"].createElement(div_1["default"], { className: (0, class_names_1["default"])('group relative flex justify-center items-center', containerClassName) },
        children,
        react_1["default"].createElement(ArrowIcon, { color: color, position: position, content: content, className: className })));
};
exports.Tooltip = Tooltip;
var ArrowIcon = function (_a) {
    var _b = _a.position, position = _b === void 0 ? 'right' : _b, _c = _a.color, color = _c === void 0 ? 'black' : _c, content = _a.content, className = _a.className;
    return (react_1["default"].createElement(div_1["default"], { className: (0, class_names_1["default"])('w-max !px-2 hidden group-hover:flex before:border-x-8 before:border-x-transparent before:border-b-8 before:absolute items-center justify-center absolute z-10 rounded-lg shadow-lg', className, tooltip_style_1.POSITIONS[position], tooltip_style_1.COLORS[color]) },
        react_1["default"].createElement(text_1["default"], { color: 'inherit' }, content)));
};
exports["default"] = exports.Tooltip;
//# sourceMappingURL=tooltip.js.map